import LoanStateService from '@services/application/LoanStateService'
import { debug } from '@/utils'

const state = () => ({
  loanState: {},
  // Admin-only: whether this loan has hit the SACC 200% payment cap (see
  // LoanStateService::isLoanCapped()). Always false on the customer portal,
  // which fetches from a different, customer-safe endpoint that never
  // returns this field.
  capped: false,
  loading: {
    getState: false,
  },
});

export const MUTATIONS = {
  SET_STATE: 'SET_STATE',
  SET_CAPPED: 'SET_CAPPED',
};

export const GETTERS = {
  STATE: 'STATE',
  CAPPED: 'CAPPED',
  LOADING: 'LOADING',
};

export const ACTIONS = {
  FETCH_STATE: 'FETCH_STATE',
};

export const MODULE_NAME = 'LOAN_STATE';

export default {
  namespaced: true,
  state,
  getters: {
    [GETTERS.STATE]: ({ loanState }) => loanState,
    [GETTERS.CAPPED]: ({ capped }) => capped,
    [GETTERS.LOADING]: ({ loading }) => loading,
  },
  mutations: {
    [MUTATIONS.SET_STATE](state, {payload}) {
      state.loanState = payload;
    },
    [MUTATIONS.SET_CAPPED](state, {payload}) {
      state.capped = !!payload;
    },
    SET_LOADING(state, {payload}) {
      state.loading = {
        ...state.loading,
        ...payload,
      };
    },
  },
  actions: {
    async [ACTIONS.FETCH_STATE]({ commit }, { payload: { loanNumber } }) {
      const setLoading = (payload) => commit({ type: 'SET_LOADING', payload });

      try {
        setLoading({ getState: true });

        const { data: { loanState, capped } } = await LoanStateService.getState({ loanNumber });

        commit({ type: MUTATIONS.SET_STATE, payload: loanState });
        commit({ type: MUTATIONS.SET_CAPPED, payload: capped });
      } catch (e) {
        debug(e);
      } finally {
        setLoading({ getState: false });
      }
    },
  }
};
